module.exports = __webpack_public_path__ + "static/media/facebook-icons-v2.9b2710fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook-icons-v2.png
// module id = 2095
// module chunks = 0